export default "__VITE_ASSET__DPTp9N_$__"